import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL, withWsDataset } from "../actions/helpers";
import axios from "axios";
const INIT_STATE = {
  sparklineData: [
    {
      twr_performance: 0,
      created_at: "",
    },
  ],
  // Period key the current sparklineData was fetched for — lets consumers
  // attribute the series to the right period without races on fast switches.
  loadedPeriod: null,
  loading: true,
  error: null,
};

// Action Types
export const PORTFOLIO_PERFORMANCE_LOAD = "PORTFOLIO/PERFORMANCE/LOAD";
export const PORTFOLIO_PERFORMANCE_LOAD_SUCCESS =
  "PORTFOLIO/PERFORMANCE/LOAD/SUCCESS";
export const PORTFOLIO_PERFORMANCE_LOAD_FAILURE =
  "PORTFOLIO/PERFORMANCE/LOAD/FAILURE";

// Action Creators
// `useRestatedDataset` (TRAD-1295) opts this fetch into the 10:00 AM ET rebalance
// series. Off by default: this duck also serves Bitcoin Navigator, which is a
// separate product on its own basis and has no v2 series behind the param.
export const portfolioPerformanceLoad = (
  portfolioId,
  period,
  useRestatedDataset = false,
) => ({
  type: PORTFOLIO_PERFORMANCE_LOAD,
  portfolioId,
  period,
  useRestatedDataset,
});

export const portfolioPerformanceLoadSuccess = (data) => ({
  type: PORTFOLIO_PERFORMANCE_LOAD_SUCCESS,
  data,
});

export const portfolioPerformanceLoadFailure = (error) => ({
  type: PORTFOLIO_PERFORMANCE_LOAD_FAILURE,
  error,
});

// Sagas
function* fetchPortfolioPerformance(action) {
  const { portfolioId, period, useRestatedDataset } = action;

  try {
    // Set loading state
    yield put(
      portfolioPerformanceLoadSuccess({
        sparklineData: null,
        loadedPeriod: null,
        loading: true,
      }),
    );

    const response = yield axios.get(
      withWsDataset(
        `${apiURL}/wealth-series/portfolios/${portfolioId}/performance?period=${period}`,
        useRestatedDataset,
      ),
      { withCredentials: true },
    );

    yield put(
      portfolioPerformanceLoadSuccess({
        sparklineData: response.data.performance.records,
        loadedPeriod: period,
        loading: false,
      }),
    );
  } catch (error) {
    yield put(portfolioPerformanceLoadFailure(error));
  }
}

function* listenPortfolioPerformanceLoad() {
  yield takeEvery(PORTFOLIO_PERFORMANCE_LOAD, fetchPortfolioPerformance);
}

// Root Saga
export function* saga() {
  yield all([fork(listenPortfolioPerformanceLoad)]);
}

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PORTFOLIO_PERFORMANCE_LOAD_SUCCESS:
      return {
        ...state,
        sparklineData: action.data.sparklineData,
        loadedPeriod: action.data.loadedPeriod ?? null,
        loading: action.data.loading,
        error: null,
      };
    case PORTFOLIO_PERFORMANCE_LOAD_FAILURE:
      return {
        ...state,
        sparklineData: INIT_STATE.sparklineData,
        loadedPeriod: null,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default reducer;
